import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { CustomerContactResponse } from '@/types/apps/customer-contact.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface CustomerContactServiceGraphQLInterface {}

type CustomerContactListResponse = GqlListResponse<CustomerContactResponse>;

export class CustomerContactGraphQLService
    extends BaseService
    implements CustomerContactServiceGraphQLInterface
{
    public getEntityName(): string {
        return 'customerContact';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            name: true,
            phoneNumber: true,
            email: true,
        };
    }

    public async index(query: string): Promise<CustomerContactListResponse> {
        return this.fetchGqlList<CustomerContactListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById()) {
            return {};
        }

        return {
            // getFilterByRole: {
            //     inputType: 'input',
            //     key: 'id',
            //     operator: '=',
            //     value: this.getQueryById(),
            // },
        };
    }
}
